// @ts-nocheck
import { populate } from 'populate';
import type { Container, Sprite, Text } from 'pixi.js';
import { ButtonLargeLayout } from '../common/buttons/ButtonLargeLayout';

const raw = {
  list: [
    {
      id: '741868d9-56e0-4191-b2b2-fd81cd99c733',
      type: 'Container',
      name: 'root',
      className: 'dynamicProps_SPL',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '',
      data: {
        dynamicValues: {
          y: 'height * -0.5'
        }
      }
    },
    {
      id: '6bc0f08c-c91f-4f7d-b376-411c99b84786',
      type: 'Sprite',
      name: '',
      className: 'dynamicProps_SPL',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 12.1875,
        y: 20
      },
      angle: 0,
      alpha: 0.7,
      visible: true,
      tint: 0,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'square_64',
      parent: '741868d9-56e0-4191-b2b2-fd81cd99c733',
      data: {
        dynamicValues: {
          height: 'height * 1.1',
          width: 'width * 1.1'
        }
      }
    },
    {
      id: '4cda3632-ffae-42a9-81d9-2860075154da',
      type: 'Sprite',
      name: '',
      className: '',
      x: 1000,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'MOCK_VS_matchPopup',
      parent: '741868d9-56e0-4191-b2b2-fd81cd99c733',
      data: {
        DEBUG: true
      }
    },
    {
      id: '0ee8572b-78d9-468f-a1d4-a48457baee4f',
      type: 'Container',
      name: 'popup',
      className: 'dynamicProps_SPL',
      x: 0,
      y: 695,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '741868d9-56e0-4191-b2b2-fd81cd99c733',
      data: {
        dynamicValues: {
          y: 'height * 0.5'
        }
      }
    },
    {
      id: '9d94ba8f-3e2f-4d1e-b3d2-a65901df3293',
      type: 'Sprite',
      name: '',
      className: 'rotate_SPL',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 2,
        y: 2
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16711680,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'versus_rays',
      parent: '0ee8572b-78d9-468f-a1d4-a48457baee4f',
      data: {
        rotationCycle: 40300
      }
    },
    {
      id: '917c5369-7f59-43e4-9b84-26790d3776f3',
      type: 'Sprite',
      name: '',
      className: 'rotate_SPL',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: -2,
        y: 2
      },
      angle: 14.4,
      alpha: 1,
      visible: true,
      tint: 16711680,
      blendMode: 1,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'versus_rays',
      parent: '0ee8572b-78d9-468f-a1d4-a48457baee4f',
      data: {
        rotationCycle: 60000
      }
    },
    {
      id: 'dee5b8f3-9678-47b7-8ac8-8c4f98b99657',
      type: 'Sprite',
      name: '',
      className: '',
      x: -258,
      y: -280,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'versus_matchPopup_piece01',
      parent: '0ee8572b-78d9-468f-a1d4-a48457baee4f'
    },
    {
      id: '253e5fd1-5777-4819-96b8-32f4f73bad5a',
      type: 'Sprite',
      name: '',
      className: '',
      x: -164,
      y: -356,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'versus_matchPopup_piece02',
      parent: '0ee8572b-78d9-468f-a1d4-a48457baee4f'
    },
    {
      id: '89a1aac7-16b7-41c5-b731-7784affd4956',
      type: 'Sprite',
      name: '',
      className: '',
      x: 269,
      y: -226,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'versus_matchPopup_piece03',
      parent: '0ee8572b-78d9-468f-a1d4-a48457baee4f'
    },
    {
      id: 'e9fc60a9-f8c9-498f-9647-c86e95ec67d5',
      type: 'Sprite',
      name: '',
      className: '',
      x: 264,
      y: 256,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'versus_matchPopup_piece04',
      parent: '0ee8572b-78d9-468f-a1d4-a48457baee4f'
    },
    {
      id: '534f3830-82da-49f6-88b1-d84135017293',
      type: 'Sprite',
      name: '',
      className: '',
      x: 0,
      y: 28,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'versus_matchPopup_body',
      parent: '0ee8572b-78d9-468f-a1d4-a48457baee4f'
    },
    {
      id: 'ea6dcb94-bb31-40a2-a9aa-c9cd4c60240c',
      type: 'Sprite',
      name: '',
      className: '',
      x: -17,
      y: 13,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'versus_matchPopup_bolt',
      parent: '0ee8572b-78d9-468f-a1d4-a48457baee4f'
    },
    {
      id: 'f30fe029-e905-4f48-87dd-9f52f16abe36',
      type: 'Sprite',
      name: 'bold_additive',
      className: '',
      x: -17,
      y: 13,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 0,
      visible: true,
      tint: 16777215,
      blendMode: 1,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'versus_matchPopup_bolt',
      parent: '0ee8572b-78d9-468f-a1d4-a48457baee4f'
    },
    {
      id: 'c4145a2e-069b-45f9-831d-10d8aa7b3d8d',
      type: 'Layout',
      name: 'playButton',
      className: '',
      path: 'common/buttons/ButtonLargeLayout.ts',
      percentX: 0,
      percentY: 0,
      handleResize: false,
      x: 0,
      y: 322,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: true,
      parent: '0ee8572b-78d9-468f-a1d4-a48457baee4f',
      data: {
        color: 'green',
        tapSound: 'UI_Button_Click'
      }
    },
    {
      id: 'e4d557a1-63dd-49ed-8f77-df5e13d01927',
      type: 'Sprite',
      name: 'closeButton',
      className: '',
      x: 274,
      y: -379,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: true,
      buttonMode: true,
      hitArea: {
        type: 'None'
      },
      texture: 'Close_Button',
      parent: '0ee8572b-78d9-468f-a1d4-a48457baee4f'
    },
    {
      id: '638b0081-fd93-4ca2-9729-51ca3277436f',
      type: 'Sprite',
      name: 'logo',
      className: '',
      x: 4,
      y: -271,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'versus_matchPopup_logo',
      parent: '0ee8572b-78d9-468f-a1d4-a48457baee4f'
    },
    {
      id: 'bcf015a6-c987-4ef7-bc99-04574ba57bc1',
      type: 'Sprite',
      name: 'vs',
      className: '',
      x: 0,
      y: 17,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'versus_matchPopup_vs',
      parent: '0ee8572b-78d9-468f-a1d4-a48457baee4f'
    },
    {
      id: '46a4b0fe-5a08-4936-93fd-b5e3d5d55c88',
      type: 'Container',
      name: 'playerContainer',
      className: '',
      x: -206,
      y: -75,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '0ee8572b-78d9-468f-a1d4-a48457baee4f'
    },
    {
      id: '705f477f-beb4-4902-92ad-44ebf65123a7',
      type: 'Container',
      name: 'enemyContainer',
      className: '',
      x: 194,
      y: 50,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '0ee8572b-78d9-468f-a1d4-a48457baee4f'
    },
    {
      id: '9f9e121f-72c2-4d95-b7e9-35a7cbff7778',
      type: 'Sprite',
      name: '',
      className: '',
      x: 0,
      y: 216,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'versus_matchPopup_rewrad',
      parent: '0ee8572b-78d9-468f-a1d4-a48457baee4f'
    },
    {
      id: 'd9b2265d-2d11-4151-b173-555b6666c36f',
      type: 'Text',
      name: '',
      className: 'variable_SPL',
      x: -52,
      y: 212,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'versus_message_p1',
      localize: true,
      maxWidth: 245,
      maxHeight: 116,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 36,
        fontWeight: 'normal',
        fontFamily: 'Baloo{wf}',
        fill: '#E9FFE3',
        stroke: 'black',
        strokeThickness: 0,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 0,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0,
        fillGradientStops: [],
        fillGradientType: 0
      },
      parent: '0ee8572b-78d9-468f-a1d4-a48457baee4f',
      data: {
        translations: {
          en_US: 'Winner gets',
          it_IT: 'Il vincitore ottiene',
          fr_FR: 'Le gagnant reçoit',
          de_DE: 'Der Gewinner erhält',
          es_ES: 'El ganador obtiene',
          pt_PT: 'O vencedor recebe',
          pl_PL: 'Zwycięzca otrzymuje',
          nl_NL: 'De winnaar krijgt',
          ko_KR: '우승자는',
          ja_JP: '勝者は'
        }
      }
    },
    {
      id: '11023e2f-0932-47eb-b0ff-9ad1575d92f7',
      type: 'Container',
      name: 'rewardContainer',
      className: 'centerChildren_SPL',
      x: 113,
      y: 216,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '0ee8572b-78d9-468f-a1d4-a48457baee4f',
      data: {
        centerChildrenPadding: 5
      }
    },
    {
      id: '42d9d72a-94b2-4990-a943-52e9aff76b7e',
      type: 'Text',
      name: '',
      className: '',
      x: -50,
      y: -4,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'Play',
      localize: true,
      maxWidth: 170,
      maxHeight: 90,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 50,
        fontWeight: 'normal',
        fontFamily: 'Baloo{wf}',
        fill: 'white',
        stroke: '#1C6417',
        strokeThickness: 7,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 0,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0,
        fillGradientStops: [],
        fillGradientType: 0
      },
      parent: 'c4145a2e-069b-45f9-831d-10d8aa7b3d8d'
    },
    {
      id: 'eb466fae-de6e-49ca-89d6-68b3b3fae47a',
      type: 'Container',
      name: '',
      className: 'centerChildren_SPL',
      x: 90,
      y: -4,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: 'c4145a2e-069b-45f9-831d-10d8aa7b3d8d',
      data: {
        centerChildrenPadding: 0
      }
    },
    {
      id: '5fe07163-caf3-4de2-8563-b4fd16206154',
      type: 'Sprite',
      name: 'playerAvatar',
      className: 'userAvatar_SPL',
      x: -53,
      y: -112,
      anchor: {
        x: 0,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 2.12,
        y: 2.12
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'avatar_placeholder',
      parent: '46a4b0fe-5a08-4936-93fd-b5e3d5d55c88'
    },
    {
      id: 'cecfd59d-fe6b-4c03-ba9d-ed31db82b35b',
      type: 'Sprite',
      name: '',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1.05,
        y: 1.05
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Player_Leaderboard_Frame',
      parent: '46a4b0fe-5a08-4936-93fd-b5e3d5d55c88'
    },
    {
      id: '678d037d-a8eb-4636-b77b-1f46e137eda4',
      type: 'Text',
      name: '',
      className: 'variable_SPL',
      x: 0,
      y: 35,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: '<player.name>',
      localize: false,
      maxWidth: 164,
      maxHeight: 77,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 30,
        fontWeight: 'normal',
        fontFamily: 'Kanit{wf}',
        fill: 'white',
        stroke: '#5F151A',
        strokeThickness: 4,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 0,
        fontStyle: 'normal',
        dropShadow: true,
        dropShadowAlpha: 1,
        dropShadowAngle: 1.57,
        dropShadowBlur: 0,
        dropShadowColor: '#5F151A',
        dropShadowDistance: 1,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0,
        fillGradientStops: [],
        fillGradientType: 0
      },
      parent: '46a4b0fe-5a08-4936-93fd-b5e3d5d55c88'
    },
    {
      id: '134853bd-8a49-4daf-a6ca-715ba824824d',
      type: 'Container',
      name: '',
      className: 'centerChildren_SPL',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '46a4b0fe-5a08-4936-93fd-b5e3d5d55c88',
      data: {
        centerChildrenPadding: 10
      }
    },
    {
      id: '1d8545ab-54ac-4616-9b74-5d860f536519',
      type: 'Sprite',
      name: 'enemyAvatar',
      className: 'insertAvatar_SPL',
      x: -45,
      y: -99,
      anchor: {
        x: 0,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1.8,
        y: 1.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'avatar_placeholder',
      parent: '705f477f-beb4-4902-92ad-44ebf65123a7',
      data: {
        insertAvatar_SPL: 'versus.enemy'
      }
    },
    {
      id: '9b343a34-2bc7-41d3-82d1-30d44a3498c7',
      type: 'Sprite',
      name: '',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1.15,
        y: 1.15
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Friends_Leaderboard_Frame',
      parent: '705f477f-beb4-4902-92ad-44ebf65123a7'
    },
    {
      id: 'a870f6d3-dce9-481f-a7a5-77a0429504ff',
      type: 'Text',
      name: '',
      className: 'variable_SPL',
      x: 0,
      y: 30,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: '<versus.enemyName>',
      localize: false,
      maxWidth: 139,
      maxHeight: 77,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 30,
        fontWeight: 'normal',
        fontFamily: 'Kanit{wf}',
        fill: 'white',
        stroke: '#5F151A',
        strokeThickness: 4,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 0,
        fontStyle: 'normal',
        dropShadow: true,
        dropShadowAlpha: 1,
        dropShadowAngle: 1.57,
        dropShadowBlur: 0,
        dropShadowColor: '#5F151A',
        dropShadowDistance: 1,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0,
        fillGradientStops: [],
        fillGradientType: 0
      },
      parent: '705f477f-beb4-4902-92ad-44ebf65123a7'
    },
    {
      id: '1dc442fb-5776-4aeb-9ad1-17681ee33adf',
      type: 'Container',
      name: '',
      className: 'centerChildren_SPL',
      x: 0,
      y: -13,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '705f477f-beb4-4902-92ad-44ebf65123a7',
      data: {
        centerChildrenPadding: 10
      }
    },
    {
      id: '6f825c39-8de1-463c-bdde-cd6849db0433',
      type: 'Sprite',
      name: '',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 16,
        y: 0
      },
      scale: {
        x: 0.6,
        y: 0.6
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Coin_Icon',
      parent: '11023e2f-0932-47eb-b0ff-9ad1575d92f7'
    },
    {
      id: 'a90388f1-88af-4807-9254-3d7cf361cd64',
      type: 'Text',
      name: '',
      className: 'variable_SPL',
      x: 0,
      y: -4,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'versus_message_p2',
      localize: true,
      maxWidth: 239,
      maxHeight: 98,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 36,
        fontWeight: 'normal',
        fontFamily: 'Baloo{wf}',
        fill: 'white',
        stroke: 'black',
        strokeThickness: 0,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 0,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0,
        fillGradientStops: [],
        fillGradientType: 0
      },
      parent: '11023e2f-0932-47eb-b0ff-9ad1575d92f7',
      data: {
        translations: {
          en_US: ' <versus.reward>',
          it_IT: ' <versus.reward>',
          fr_FR: ' <versus.reward>',
          de_DE: ' <versus.reward>',
          es_ES: ' <versus.reward>',
          pt_PT: ' <versus.reward>',
          pl_PL: ' <versus.reward>',
          nl_NL: ' <versus.reward>',
          ko_KR: ' <versus.reward>을 받습니다',
          ja_JP: ' <versus.reward> を獲得します'
        }
      }
    },
    {
      id: '0ddd531f-0343-41b8-9c28-da1e5659f056',
      type: 'Sprite',
      name: '',
      className: '',
      x: -17,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'coin',
      parent: 'eb466fae-de6e-49ca-89d6-68b3b3fae47a'
    },
    {
      id: '61e7f3bd-0d02-4b7a-8ae0-ea1f328a9276',
      type: 'Text',
      name: '',
      className: 'variable_SPL',
      x: 26,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: '<versus.cost>',
      localize: false,
      maxWidth: 0,
      maxHeight: 0,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 50,
        fontWeight: 'normal',
        fontFamily: 'Baloo{wf}',
        fill: 'white',
        stroke: '#24591B',
        strokeThickness: 7,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 0,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0,
        fillGradientStops: [],
        fillGradientType: 0
      },
      parent: 'eb466fae-de6e-49ca-89d6-68b3b3fae47a'
    },
    {
      id: '5f19a15e-32a9-46f2-b386-f3b773bd6f34',
      type: 'Text',
      name: '',
      className: '',
      x: -17,
      y: 100,
      anchor: {
        x: 0.5,
        y: 1
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'Lvl',
      localize: true,
      maxWidth: 0,
      maxHeight: 0,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 26,
        fontWeight: 'normal',
        fontFamily: 'Kanit{wf}',
        fill: 'white',
        stroke: 'black',
        strokeThickness: 0,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 0,
        fontStyle: 'normal',
        dropShadow: true,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 3,
        dropShadowColor: '#7C180C',
        dropShadowDistance: 0,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0,
        fillGradientStops: [],
        fillGradientType: 0
      },
      parent: '134853bd-8a49-4daf-a6ca-715ba824824d'
    },
    {
      id: '23251d25-a137-48ef-94af-65a77d4058b7',
      type: 'Text',
      name: '',
      className: 'variable_SPL',
      x: 26,
      y: 101,
      anchor: {
        x: 0.5,
        y: 1
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: '<player.level>',
      localize: false,
      maxWidth: 0,
      maxHeight: 0,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 32,
        fontWeight: 'normal',
        fontFamily: 'Kanit{wf}',
        fill: 'white',
        stroke: 'black',
        strokeThickness: 0,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 0,
        fontStyle: 'normal',
        dropShadow: true,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 3,
        dropShadowColor: '#7C180C',
        dropShadowDistance: 0,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0,
        fillGradientStops: [],
        fillGradientType: 0
      },
      parent: '134853bd-8a49-4daf-a6ca-715ba824824d'
    },
    {
      id: '909ff385-75ef-4389-b0c1-75fcf7a3381d',
      type: 'Text',
      name: '',
      className: '',
      x: -17,
      y: 100,
      anchor: {
        x: 0.5,
        y: 1
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'Lvl',
      localize: true,
      maxWidth: 0,
      maxHeight: 0,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 26,
        fontWeight: 'normal',
        fontFamily: 'Kanit{wf}',
        fill: 'white',
        stroke: 'black',
        strokeThickness: 0,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 0,
        fontStyle: 'normal',
        dropShadow: true,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 3,
        dropShadowColor: '#7C180C',
        dropShadowDistance: 0,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0,
        fillGradientStops: [],
        fillGradientType: 0
      },
      parent: '1dc442fb-5776-4aeb-9ad1-17681ee33adf'
    },
    {
      id: '2c3d86d9-d3c6-4901-a814-ff0a3b29d3bc',
      type: 'Text',
      name: '',
      className: 'variable_SPL',
      x: 26,
      y: 101,
      anchor: {
        x: 0.5,
        y: 1
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: '<versus.enemyLevel>',
      localize: false,
      maxWidth: 0,
      maxHeight: 0,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 32,
        fontWeight: 'normal',
        fontFamily: 'Kanit{wf}',
        fill: 'white',
        stroke: 'black',
        strokeThickness: 0,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 0,
        fontStyle: 'normal',
        dropShadow: true,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 3,
        dropShadowColor: '#7C180C',
        dropShadowDistance: 0,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0,
        fillGradientStops: [],
        fillGradientType: 0
      },
      parent: '1dc442fb-5776-4aeb-9ad1-17681ee33adf'
    }
  ],
  x: 0,
  y: 0,
  width: 760,
  height: 760,
  version: '4.0.1',
  animations: [
    {
      id: 'd75f4c8c-879d-42ae-be7f-37b18bd5bdd3',
      name: 'Appear',
      playingSpeed: 1,
      totalDuration: 1000,
      blocks: [
        {
          id: '5ce193f7-6187-49f7-bea7-8f9ad69101af',
          type: 'Setter',
          name: 'New_setter',
          track: 1,
          target: {
            scale: {
              x: 0,
              y: 0
            }
          },
          startAt: 0,
          sourceName: 'popup',
          disabled: false
        },
        {
          id: 'bcb7f697-d886-4797-81b4-97897ae99733',
          type: 'Tween',
          name: 'New_tween',
          duration: 300,
          track: 1,
          target: {
            scale: {
              x: 1,
              y: 1
            }
          },
          startAt: 0,
          sourceName: 'popup',
          easing: 'QuadraticOut',
          disabled: false
        }
      ]
    }
  ],
  handleResize: false
} as const;

export class VersusPopupLayout {
  static raw = raw;
  root!: Container & { data: typeof raw['list'][0]['data'] };
  popup!: Container & { data: typeof raw['list'][3]['data'] };
  bold_additive!: Sprite;
  playButton!: ButtonLargeLayout & { data: typeof raw['list'][13]['data'] };
  closeButton!: Sprite;
  logo!: Sprite;
  vs!: Sprite;
  playerContainer!: Container;
  enemyContainer!: Container;
  rewardContainer!: Container & { data: typeof raw['list'][21]['data'] };
  playerAvatar!: Sprite;
  enemyAvatar!: Sprite & { data: typeof raw['list'][28]['data'] };
  dynamicProps_SPL!: (Container & { data: typeof raw['list'][0]['data'] } | Sprite & { data: typeof raw['list'][1]['data'] } | Container & { data: typeof raw['list'][3]['data'] })[];
  rotate_SPL!: (Sprite & { data: typeof raw['list'][4]['data'] } | Sprite & { data: typeof raw['list'][5]['data'] })[];
  variable_SPL!: (Text & { data: typeof raw['list'][20]['data'] } | Text | Text & { data: typeof raw['list'][33]['data'] })[];
  centerChildren_SPL!: (Container & { data: typeof raw['list'][21]['data'] } | Container & { data: typeof raw['list'][23]['data'] } | Container & { data: typeof raw['list'][27]['data'] } | Container & { data: typeof raw['list'][31]['data'] })[];
  userAvatar_SPL!: (Sprite)[];
  insertAvatar_SPL!: (Sprite & { data: typeof raw['list'][28]['data'] })[];
  StateName!: never;

  constructor() {
    populate(this, raw);
  }
}

export abstract class Appear {
  Layout: {
    popup: object;
  };

  BlockTypeByName: {
    New_setter: object;
    New_tween: object;
  };

  flowData = raw.animations[0];
}
